/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "fees": {
        "nested": {
          "SimpleRate": {
            "fields": {
              "basisPoints": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              },
              "fixedAmount": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "PaymentPriceAllocationAttributes": {
            "fields": {
              "paymentPriceSpec": {
                "type": ".squareup.fees.PaymentPriceAllocationSpec",
                "id": 1,
                "rule": "optional"
              },
              "appPlatformToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "PaymentPriceAllocationSpec": {
            "fields": {
              "party": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "priceSelectors": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              },
              "feeCalculationAmount": {
                "type": ".squareup.common.Money",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "RefundPaymentFeesSpec": {
            "fields": {
              "refundId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "priceAllocationSpec": {
                "type": ".squareup.fees.PaymentPriceAllocationSpec",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "PaymentFeesSpec": {
            "fields": {
              "priceAllocationSpec": {
                "type": ".squareup.fees.PaymentPriceAllocationSpec",
                "id": 1,
                "rule": "repeated"
              },
              "squareFeePayer": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.fees?.nested?.SimpleRate && !$root.nested?.squareup?.nested?.fees?.nested?.PaymentPriceAllocationAttributes && !$root.nested?.squareup?.nested?.fees?.nested?.PaymentPriceAllocationSpec && !$root.nested?.squareup?.nested?.fees?.nested?.RefundPaymentFeesSpec && !$root.nested?.squareup?.nested?.fees?.nested?.PaymentFeesSpec) {
	$root.addJSON(jsonData);
}

/**
 * @desc Describes a simple rate with a variable and fixed component.
 *
 * SOURCE SimpleRate @ squareup/fees/models.proto at 72:1
 */
export const SimpleRate = $root.lookupType('squareup.fees.SimpleRate');
fixType(SimpleRate);
Builder.createAndAttachToType(SimpleRate);
/**
 * --
 * @desc Encapsulates attributes clients need to provide with the payment in order to use payment prices.
 * --
 *
 * SOURCE PaymentPriceAllocationAttributes @ squareup/fees/models.proto at 120:1
 */
export const PaymentPriceAllocationAttributes = $root.lookupType('squareup.fees.PaymentPriceAllocationAttributes');
fixType(PaymentPriceAllocationAttributes, {
  paymentPriceSpec: { required: true },
  appPlatformToken: { required: true },
});
Builder.createAndAttachToType(PaymentPriceAllocationAttributes);
/**
 * SOURCE PaymentPriceAllocationSpec @ squareup/fees/models.proto at 132:1
 */
export const PaymentPriceAllocationSpec = $root.lookupType('squareup.fees.PaymentPriceAllocationSpec');
fixType(PaymentPriceAllocationSpec, {
  party: { notEmpty: true },
  priceSelectors: { required: true },
});
Builder.createAndAttachToType(PaymentPriceAllocationSpec);
/**
 * SOURCE RefundPaymentFeesSpec @ squareup/fees/models.proto at 162:1
 */
export const RefundPaymentFeesSpec = $root.lookupType('squareup.fees.RefundPaymentFeesSpec');
fixType(RefundPaymentFeesSpec, {
  refundId: { notEmpty: true },
  priceAllocationSpec: { required: true },
});
Builder.createAndAttachToType(RefundPaymentFeesSpec);
/**
 * --
 * @desc Defines the parameters on how payment fees should be calculated and used
 * by the [CreatePayment] and [RefundPayment] endpoints.
 * --
 *
 * SOURCE PaymentFeesSpec @ squareup/fees/models.proto at 178:1
 */
export const PaymentFeesSpec = $root.lookupType('squareup.fees.PaymentFeesSpec');
fixType(PaymentFeesSpec, {
  priceAllocationSpec: { required: true },
});
Builder.createAndAttachToType(PaymentFeesSpec);
